import { Classes, IconSize } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'bones/components/atoms/icons/types';

export const VoiceboxLogo: React.VFC<
  {
    /* whether to use the multi-colored logo */
    colorful?: boolean;
  } & IconProps &
    React.SVGProps<SVGSVGElement>
> = ({
  className,
  color = 'currentColor',
  colorful,
  size = IconSize.STANDARD,
  title,
  ...extraProps
}) => (
  <svg
    className={classNames(Classes.ICON, 'sd-icon', className)}
    fill="none"
    height={size}
    viewBox="0 0 500 500"
    width={size}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...extraProps}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M58.5705 404.817L8.30553 257.614C-0.530635 231.737 10.6064 203.262 34.654 190.246L105.733 151.775L179.265 467L128.46 461.138C96.2478 457.422 69.0487 435.503 58.5705 404.817Z"
      fill={colorful ? '#007FA4' : color}
    />
    <path
      d="M331.289 237.653C332.501 241.578 333.568 245.728 334.484 250.096C343.951 295.246 337.123 346.744 301.553 356.274C265.984 365.805 235.267 339.242 225.8 294.092C216.332 248.942 228.263 202.084 263.833 192.553C279.881 188.253 293.902 190.356 305.329 198.105L336.588 125.561L138.834 142.914L206.886 462.395L381.217 391.087L367.457 211.644L331.289 237.653Z"
      fill={colorful ? '#003E51' : color}
    />
    <path
      d="M364.788 176.835L362.095 141.718L338.96 195.408L364.788 176.835Z"
      fill={colorful ? '#003E51' : color}
    />
    <path
      d="M373.094 207.59L482.883 189.946C496.102 171.92 497.192 147.896 489.887 123.602L373.094 207.59Z"
      fill={colorful ? '#EF6A3F' : color}
    />
    <path
      d="M477.821 95.5503C462.554 68.3136 438.07 43.6649 410.079 30.3593L338.96 195.407L477.821 95.5503Z"
      fill={colorful ? '#EF6A3F' : color}
    />
    <path
      d="M381.545 21.2264C365.406 18.5601 348.785 20.0987 332.6 27.2501L337.023 124.549L381.545 21.2264Z"
      fill={colorful ? '#EF6A3F' : color}
    />
  </svg>
);
